var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.element,{tag:"component",class:{ 'disabled': _vm.c_disabled, 'error': _vm.error, 'loading': _vm.loading, 'success': _vm.success },attrs:{"disabled":_vm.c_disabled,"theme":_vm.theme},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }